import { setJsonItem, getJsonItem } from "services/localStorage";
import { nanoid } from "nanoid";

/**
 * Retrieves the connection ID from local storage if it exists.
 * If not, it generates a new connection ID using FingerprintJS,
 * stores it in local storage, and returns it.
 *
 * @returns {Promise<string>} The connection ID.
 */
export const getConnectionId = async () => {
  const visitorId = getJsonItem("visitorId");

  if (visitorId) {
    return visitorId;
  }

  const id = nanoid();

  setJsonItem({
    key: "visitorId",
    value: id,
  });

  return id;
};
